export default "__VITE_ASSET__e51472ff__"